import React, { } from "react";
import { LabelModes } from "../../../ui-components/molecules/labeled-inputs/labeledInput";
import { Address } from "../../../app/data/terminal-details/models";
import {
  useFormikContext,
} from 'formik';
import XGSFormInput from "../../../ui-components/form/input/xgsFormInput";
import XGSFormSelect from "../../../ui-components/form/select/xgsFormSelect";
import { countryOptions } from "app/data/terminal-details/models";
import usaStates from "app/data/common/usaStates";

interface AddressFormProps {
  isMailingAddress?: boolean;
  isSameAsPhysical?: boolean;
}


const AddressForm = ({ isMailingAddress, isSameAsPhysical }: AddressFormProps): React.ReactElement => {

  const { values , setFieldValue } = useFormikContext<Address>();

  return (<div className="edit-flex-box">
    <XGSFormInput
      type="text"
      name={isMailingAddress ? "mailingAddress" : "street"}
      required={isSameAsPhysical ? false : true}
      labelMode={LabelModes.column}
      label={isMailingAddress ? "P.O. Box or Street Address" : "Street Address"}
      disabled={isSameAsPhysical}
    />
    <div className="edit-flex-box__item">
      <XGSFormInput
        type="text"
        name={isMailingAddress ? "mailingCity" : "city"}
        required={isSameAsPhysical ? false : true}
        labelMode={LabelModes.column}
        label="City"
        className="width-50"
        disabled={isSameAsPhysical}
      />
      <XGSFormSelect
        label="State"
        name={isMailingAddress ? "mailingStateProvince" : "state"}
        required={isSameAsPhysical ? false : true}
        options={usaStates}
        value={isMailingAddress ? values?.mailingStateProvince ? usaStates.find(
          (option) => option.value === values.mailingStateProvince
        ) : null : values?.state ? usaStates.find(
          (option) => option.value === values.state
        ) : null}
        onValueChange={(option) => {
          setFieldValue(isMailingAddress ? "mailingStateProvince" : "state", option?.value ?? "");
        }}
        formik
        className="width-50"
        labelMode={LabelModes.column}
        disabled={isSameAsPhysical}
      />
    </div>
    <div className="edit-flex-box__item">
      <XGSFormInput
        type="text"
        name={isMailingAddress ? "mailingZipPostalCode" : "zip"}
        required={isSameAsPhysical ? false : true}
        labelMode={LabelModes.column}
        label="ZIP/Postal Code"
        className="width-50"
        disabled={isSameAsPhysical}
      />
      <XGSFormSelect
        label="Country"
        name={isMailingAddress ? "mailingCountry" : "country"}
        required={isSameAsPhysical ? false : true}
        options={countryOptions}
        value={isMailingAddress ? values?.mailingCountry ? countryOptions.find(
          (option) => option.value === values.mailingCountry
        ) : null : values?.country ? countryOptions.find(
          (option) => option.value === values.country
        ) : null}
        onValueChange={(option) => {
          setFieldValue(isMailingAddress ? "mailingCountry" : "country", option?.value ?? "");
        }}
        formik
        className="width-50"
        labelMode={LabelModes.column}
        disabled={isSameAsPhysical}
      />
    </div>
  </div>)
};




export default AddressForm;
